<script>
export default {
  name: "Breadcrumb",
  props: {
    // Itens após "Início": { text: String, to: String (opcional) }
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // Último item fica ativo; oculto no mobile quando houver itens intermediários
    itemClass(index) {
      const isLast = index === this.items.length - 1;
      return {
        active: isLast,
        "d-none d-sm-block": isLast && this.items.length > 1,
      };
    },
  },
};
</script>

<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <router-link tag="a" to="/" aria-label="Início">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
          <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
          </path>
        </svg>
      </router-link>
    </li>
    <li v-for="(item, index) in items" :key="index" class="breadcrumb-item" :class="itemClass(index)">
      <router-link v-if="item.to" tag="a" :to="item.to">{{ item.text }}</router-link>
      <template v-else>{{ item.text }}</template>
    </li>
  </ol>
</template>
